module.exports = __webpack_public_path__ + "img/Phoesvg.0c2fe1e7.svg";